import { render, staticRenderFns } from "./advance.vue?vue&type=template&id=11996700&scoped=true"
import script from "./advance.vue?vue&type=script&lang=js"
export * from "./advance.vue?vue&type=script&lang=js"
import style0 from "./advance.vue?vue&type=style&index=0&id=11996700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11996700",
  null
  
)

export default component.exports